<script>
  import LogActivityModal from "../../elements/ProfileContactSideBarShared/ContactCtas/PopUpModals/LogActivityModal.svelte";
  import SendMessageModal from "../../elements/ProfileContactSideBarShared/ContactCtas/PopUpModals/SendMessageModal.svelte";
  import AddManualToDoModal from "../../modals/AddManualToDoModal/AddManualToDoModal.svelte";
  import AssignTaskToContactModal from "../../modals/AssignTaskToContactModal/AssignTaskToContactModal.svelte";
  import AddToCampaignModal from "../AddToCampaign/AddToCampaignModal.svelte";
  import AddContactToProject from "./PopUpModals/AddContactToProject/AddContactToProject.svelte";
  import AddFileModal from "./PopUpModals/AddFileModal/AddFileModal.svelte";
  import FlagContact from "./PopUpModals/FlagContact/FlagContact.svelte";
  import ShareResume from "./PopUpModals/ShareResume/ShareResume.svelte";
  import TodosConfirmNavigation from "./PopUpModals/TodosConfirmNavigation.svelte";
  import UploadCV from "./PopUpModals/UploadCV/UploadCV.svelte";
  import { activePopUpModalStore, avatarProps, jobInfo } from "./stores";

  $: modal = $activePopUpModalStore?.modal;
</script>

<!-- activePopUpModalStore should contain the modal type and any necessary data -->

{#if modal === "addManualToDo"}
  {@const { actionedFrom, selectedCandidateId, onclose } =
    $activePopUpModalStore}
  <AddManualToDoModal {actionedFrom} {selectedCandidateId} {onclose} />
{:else if modal === "addToCampaign"}
  {@const { actionedFrom, candidates, callback } = $activePopUpModalStore}
  <AddToCampaignModal
    {actionedFrom}
    {candidates}
    {callback}
    avatarProps={$avatarProps}
    jobInfo={$jobInfo}
  />
  <!-- avatarProps and jobInfo are passed to the modal here because
       they are not available to the contact ctas context -->
{:else if modal === "addContactToProject"}
  <AddContactToProject />
{:else if modal === "flagContact"}
  {@const { contactToFlag } = $activePopUpModalStore}
  <FlagContact {contactToFlag} />
{:else if modal === "logActivity"}
  {@const { kind, label } = $activePopUpModalStore}
  <LogActivityModal {kind} {label} />
{:else if modal === "confirmNavigation"}
  {@const { confirm, cancel } = $activePopUpModalStore}
  <TodosConfirmNavigation {confirm} {cancel} />
{:else if modal === "sendMessage"}
  {@const { kind, number } = $activePopUpModalStore}
  <SendMessageModal {kind} {number} />
{:else if modal === "uploadCV"}
  <UploadCV />
{:else if modal === "addFile"}
  <AddFileModal />
{:else if modal === "assignToContact"}
  {@const { toDoId, onclose, onclickAdd } = $activePopUpModalStore}
  <AssignTaskToContactModal {toDoId} {onclose} {onclickAdd} />
{:else if modal === "shareResume"}
  <ShareResume />
{/if}
